import { styled } from '@mui/material'

export const Div = styled('div')`
  width: 100%;
  display: flex;
`
